import CUSTOM_INDEX from "src/customs";

function loadCustom(id: string | number, type: string, apply: string) {
  const customId = id ? id.toString() : "";
  if (!customId || customId.length === 0) {
    console.error("Invalid ID parameter. Not possible to load custom data.");
    return null;
  }
  try {
    const custom = CUSTOM_INDEX.find(
      (item) =>
        item.id === customId && item.type === type && item.apply === apply
    );
    if (custom) {
      const fileName = custom.file.replace(".json", "");
      return require(`src/customs/${fileName}.json`);
    }
    return null;
  } catch (err) {
    console.error(err);
  }
  return null;
}

export default loadCustom;
